import React from 'react';
import { customerInfo as customerInfoShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { membershipStatusTiers } from 'types/tiers';
import TierInfo from './TierInfo';
import BusinessRewardsBenefits from './BusinessRewardsBenefits';

import { pointsToRemainInTier } from './MemberInfo.utils';
import {
  MemberInfoSection,
  MemberInfoContainer,
  TierName,
  MemberInfoRow,
  MemberInfoColumn,
  MemberName
} from '../ClubEurostarMember.styles';
import moment from 'moment';

const formatMembershipStatus = (membershipStatus) => {
  switch (membershipStatus) {
    case membershipStatusTiers.ACTIVE:
      return <FormattedMessage id="clubEurostar.membershipActive" />;
    case membershipStatusTiers.INACTIVE:
      return <FormattedMessage id="clubEurostar.membershipClosed" />;
    default:
      return '-';
  }
};

const MemberInfo = ({ customerInfo }) => (
  <MemberInfoContainer>
    <MemberInfoSection>
      <MemberInfoRow>
        <MemberInfoColumn data-testid="membershipInfo">
          <MemberName>
            <strong>
              {customerInfo.firstName} {customerInfo.lastName}
            </strong>
          </MemberName>
          <div>
            <FormattedMessage id="paxForm.loyaltyNumber" />
            {`: `}
            <strong>{customerInfo.profile.loyalty.membershipNumber}</strong>
          </div>
          <div>
            <FormattedMessage id="clubEurostar.membershipStatus" />
            {`: `}
            <strong>{formatMembershipStatus(customerInfo.profile.loyalty.status)}</strong>
          </div>
        </MemberInfoColumn>
      </MemberInfoRow>
      <MemberInfoRow align="flex-start">
        <MemberInfoColumn data-testid="membershipAdditionalInfo">
          <div>
            <FormattedMessage id="clubEurostar.membershipEnrollmentDate" />
            {`: `}
            <strong>{moment(customerInfo.profile.loyalty.registrationDateTime).format('Do MMMM YYYY')}</strong>
          </div>
          <div>
            <FormattedMessage id="clubEurostar.manualTierImmunityLevel" />
            {`: `}
            <strong>{customerInfo.profile.loyalty.tier?.manualTierImmunityLevel ?? <FormattedMessage id="interaction.no" />}</strong>
          </div>
          <div>
            <FormattedMessage id="clubEurostar.subscriptionTierImmunityLevel" />
            {`: `}
            <strong>{customerInfo.profile.loyalty.tier?.subscriptionTierImmunityLevel ?? <FormattedMessage id="interaction.no" />}</strong>
          </div>
        </MemberInfoColumn>
      </MemberInfoRow>
    </MemberInfoSection>
    <MemberInfoSection>
      <MemberInfoRow>
        <div data-testid="currentTier" style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
          <TierName>
            <FormattedMessage id="clubEurostar.currentTier" />
            {`: `}
            <strong>{customerInfo.profile.loyalty.tier.name}</strong>
          </TierName>
          <TierInfo
            tierName={customerInfo.profile.loyalty.tier.name}
            activePoints={customerInfo.profile.loyalty.rewardPoints ?? 0}
            statusPoints={customerInfo.profile.loyalty.statusPoints ?? 0}
            pointsToRemainInTier={pointsToRemainInTier({ loyalty: customerInfo.profile.loyalty })}
            tierToDate={customerInfo.profile.loyalty.tier.pointsResetDate}
            customerEmail={customerInfo.emailAddress}
            customerName={customerInfo.lastName}
            pointsResetDate={customerInfo.profile.loyalty?.tier?.pointsResetDate}
            customerTier={customerInfo.profile.loyalty?.tier?.tierCode}
          />
        </div>
      </MemberInfoRow>
      <MemberInfoRow align="flex-start">
        <div data-testid="nextTier" style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
          {customerInfo.profile.loyalty.tier.nextTierName && (
            <>
              <TierName>
                <FormattedMessage id="clubEurostar.nextTier" />
                {`: `}
                <strong>{customerInfo.profile.loyalty.tier.nextTierName}</strong>
              </TierName>
              <TierInfo
                nextTier
                tierName={customerInfo.profile.loyalty.tier.nextTierName}
                pointsToNextTier={customerInfo.profile.loyalty.tier.pointsToNextTier}
                numberOfTripsToNextTier={customerInfo.profile.loyalty.tier.tripsToNextTier}
              />
            </>
          )}
        </div>
      </MemberInfoRow>
    </MemberInfoSection>

    <MemberInfoSection>
      <MemberInfoRow>
        <BusinessRewardsBenefits membershipNumber={customerInfo.profile?.loyalty?.membershipNumber} />
      </MemberInfoRow>
    </MemberInfoSection>
  </MemberInfoContainer>
);

MemberInfo.propTypes = {
  customerInfo: customerInfoShape
};

export default MemberInfo;
